/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Section from "../layouts/Section";
import { servicePath } from "../../constants/defaultsValues";
import { Calendar } from "react-calendar";

const apiUrl = `${servicePath}/reservations`;
const apiDays = `${servicePath}/days`;
const apiAreas = `${servicePath}/areas`;
const apiReservationQuota = `${servicePath}/reservations/quota`;
const apiScheduleAreas = `${servicePath}/schedule-common-areas`;
const Create = () => {
  const resident = useSelector((state) => state.resident);
  const address = useSelector((state) => state.address);
  const condominium = useSelector((state) => state.condominium);
  const token = useSelector((state) => state.jwt);
  const [areas, setAreas] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const [days, setDays] = useState([]);
  const [date, setDate] = useState(null);
  const [blocksData, setBlocksData] = useState([]);
  const [blockArea, setBlockArea] = useState([]);
  const [schedulesData, setSchedulesData] = useState([]);
  const [confirmation, setConfirmation] = useState(false);
  const [reservation, setReservation] = useState({});

  async function fetchData() {
    setDate(new Date());
    const idCondominio = resident.addresses.find(
      (r) => r.id === address
    ).condominium;
    const firstRequest = axios.get(
      `${apiAreas}?_limit=-1&_sort=id&addresses=${address}&reserva=true`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const secondRequest = axios.get(
      `${apiScheduleAreas}?_limit=-1&_sort=start&area.condominium=${idCondominio}&status=true`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const thirdRequest = axios.get(
      `${apiScheduleAreas}?_limit=-1&_sort=end&area.condominium=${idCondominio}&status=true`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const forthRequest = axios.get(`${apiDays}?_limit=-1&_sort=value`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const [firstResponse, secondResponse, thirdResponse, fourthResponse] =
      await Promise.all([
        firstRequest,
        secondRequest,
        thirdRequest,
        forthRequest,
      ]);
    const blocksStart = secondResponse.data;
    const blocksEnd = thirdResponse.data;
    if (blocksStart.length) {
      let start = blocksStart.find((block, k) => k === 0);
      let end = blocksEnd.find((block, k) => k === blocksEnd.length - 1);
      start = moment(start.start, "HH:mm:ss").format("HH");
      end = moment(end.end, "HH:mm:ss").format("HH");

      const array = [];
      for (let i = Number(start); i < Number(end); i += 1) {
        array.push({
          time: moment(i, "HH").format("HH:00"),
          start: i,
          end: i + 1,
        });
      }
      setBlockArea(array);
    }
    setDays(fourthResponse.data);
    setAreas(firstResponse.data);
    setIsLoaded(true);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async () => {
    setIsLoaded(false);
    const values = {
      area: areas.find((item) => item.id === selectedArea.id),
      date: date,
      start: reservation.start
        ? moment(reservation.start, "HH:mm").format("HH:mm:ss.SSS")
        : null,
      end: reservation.end
        ? moment(reservation.end, "HH:mm").format("HH:mm:ss.SSS")
        : null,
      amount: reservation.price,
      status: "pending",
      resident: resident,
      blockArea: blockArea,
      address: address,
      condominium,
    };
    if (values.amount > 0) {
      await axios
        .post(`${apiReservationQuota}`, values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          setIsLoaded(true);
          setConfirmation(true);
        })
        .catch((err) => {
          setIsLoaded(true);
          console.log(err);
        });
    } else {
      await axios
        .post(`${apiUrl}`, values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          setIsLoaded(true);
          setConfirmation(true);
        })
        .catch((err) => {
          setIsLoaded(true);
          console.log(err);
        });
    }
  };
  return (
    <Section
      title={"Reservaciones"}
      withBack={true}
      noBorder={true}
      cancelTo="/reservations"
    >
      {isLoaded ? (
        <div className="transaction-area pt-5 ">
          {selectedArea === null ? (
            <>
              {areas.length ? (
                <AreaSelect areas={areas} setSelectedArea={setSelectedArea} />
              ) : (
                <h2 className="mx-auto text-center text-blue mt-5">
                  No tienes areas disponibles
                </h2>
              )}
            </>
          ) : !confirmation ? (
            <PickDate
              date={date}
              setDate={setDate}
              setBlocksData={setBlocksData}
              blocksData={blocksData}
              setSchedulesData={setSchedulesData}
              schedulesData={schedulesData}
              selectedArea={selectedArea}
              setBlockArea={setBlockArea}
              blockArea={blockArea}
              setReservation={setReservation}
              reservation={reservation}
              areas={areas}
              days={days}
              onSubmit={onSubmit}
            />
          ) : (
            <Confirm
              selectedArea={selectedArea}
              reservation={reservation}
              date={date}
            />
          )}
        </div>
      ) : (
        ""
      )}
    </Section>
  );
};

const AreaCard = ({ area, setSelectedArea }) => {
  return (
    <div
      type="button"
      onClick={() => setSelectedArea(area)}
      className="card-area btn-area border-0 mb-2"
      style={{ backgroundColor: "#f8f7f7" }}
    >
      {/* <div className="w-100">
                        <div
                          className={`status ${x.status?.id === 1 ? "bg-red" : ""
                            } ${x.status?.id === 2 ? "bg-orange" : ""} ${x.status?.id === 3 ? "bg-green" : ""
                            }`}
                        ></div>
                      </div> */}
      <div className="col-12">
        {/* <Link to={`/incidences/resumen/${x.id}`}> */}
        {/* <Link
                          to={`/incidences/monitoring/${x.id}`}
                          className="col-10 p-0 d-flex align-items-center container-text"
                        > */}
        <div className="col-10 w-100 d-flex align-items-center">
          <div className="w-30">
            {area.icon && (
              <img
                className=""
                src={`/assets/icons/${area.icon?.fileName}`}
                width="40"
                height="40"
                alt="icon"
              />
            )}
          </div>
          <div className="w-80 details">
            <h5 className="w-100">{area.name}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

function AreaSelect({ areas, setSelectedArea }) {
  return (
    <div className="container pt-4">
      <div className="col-8 mx-auto text-center text-title">
        Selecciona donde deseas hacer tu reservación
      </div>
      <div className="transaction-area pt-3 section-incidences">
        <ul className="transaction-inner row align-items-stretch">
          {areas &&
            areas.map((area, key) => (
              <li key={key} className="col-12 col-sm-12 col-md-6 col-xl-4 my-1">
                <AreaCard area={area} setSelectedArea={setSelectedArea} />
              </li>
            ))}
        </ul>
      </div>
      <div className="w-70 mx-auto my-4">
        <h4 className="text-title">Notas:</h4>
        <p>
          Es importante mencionar que una vez que se genera una reservación esta
          debe ser respetada, si no se podrá utilizar por cualquier motivo es
          importante que libere el horario reservado para que otros puedan hacer
          uso de las áreas.
        </p>
      </div>
    </div>
  );
}

function PickDate({
  selectedArea,
  areas,
  setDate,
  date,
  setBlocksData,
  blocksData,
  setSchedulesData,
  schedulesData,
  setBlockArea,
  blockArea,
  days,
  reservation,
  setReservation,
  onSubmit,
}) {
  const getAvailability = (
    duration,
    timeStart,
    timeEnd,
    reservations,
    priceData
  ) => {
    const start = Number(moment(timeStart, "HH:mm:ss").format("HH"));
    const end = Number(moment(timeEnd, "HH:mm:ss").format("HH"));
    let total = 0;
    const schedulesArray = [];
    for (let i = start; i < end; i += duration) {
      if (reservations.length) {
        const isReserved = reservations.find(
          (reserva) =>
            Number(moment(reserva.start, "HH:mm:ss").format("HH")) === i ||
            (Number(moment(reserva.start, "HH:mm:ss").format("HH")) < i &&
              Number(moment(reserva.end, "HH:mm:ss").format("HH")) > i) ||
            (i < Number(moment(reserva.start, "HH:mm:ss").format("HH")) &&
              i + duration >
                Number(moment(reserva.start, "HH:mm:ss").format("HH")))
        );
        if (!isReserved) {
          schedulesArray.push({
            start: i,
            end: i + duration,
            price: priceData,
          });
          total += 1;
        }
      } else {
        schedulesArray.push({ start: i, end: i + duration, price: priceData });
        total += 1;
      }
    }
    const retorno = {
      availability: total.toString().concat(" Disponible"),
      schedules: schedulesArray,
    };
    return retorno;
  };

  const getBlocks = (area, date) => {
    setSchedulesData([]);
    let areaData = [];
    let blocks = [];

    if (area && date) {
      const day = days.find((d) => d.value === Number(moment(date).day())).id;
      areaData = areas.find((x) => x.id === Number(area.id));
      blocks = areaData.blockAreas;
      const schedule = areaData.scheduleAreas.find((s) => s.day === day);
      const reservations = areaData.reservations
        ? areaData.reservations.filter(
            (reserva) =>
              moment(reserva.date).format("DD-MM-YYYY") ===
              moment(date).format("DD-MM-YYYY")
          )
        : [];
      blocks.forEach(async (block, i) => {
        const price = areaData.cost ? block.cost : 0;
        const getData = schedule.status
          ? await getAvailability(
              block.duration,
              schedule.start,
              schedule.end,
              reservations,
              price
            )
          : null;
        blocks[i].availability =
          getData && getData.availability
            ? getData.availability
            : "No Disponible";
        blocks[i].schedules =
          getData && getData.schedules ? getData.schedules || [] : [];
        // if (edit && (editItem || {})) {
        //   setSchedulesData(blocks[i].schedules || []);
        // }
      });
    }
    setBlockArea([]);
    setBlocksData(blocks);
  };

  const handleSetSchedulesData = (schedules) => {
    const selectedDate = moment(date).format("D-MM-yyyy");
    const currentDate = moment().format("D-MM-yyyy");

    const filteredSchedules = schedules.filter((schedule) => {
      if (selectedDate === currentDate && schedule.start <= moment().hour()) {
        return false;
      }
      return true;
    });
    setSchedulesData(filteredSchedules);
  };

  return (
    <div className="container pt-4">
      <div className="col-8 mx-auto text-center text-title">
        Selecciona día y hora <br /> Para realizar tu reserva
      </div>
      <div className="transaction-area pt-3 section-incidences">
        <ul className="transaction-inner row align-items-stretch">
          <li className="col-12 col-sm-12 col-md-6 col-xl-4 my-1">
            <AreaCard area={selectedArea} />
          </li>
          <li className="col-12 col-sm-12 col-md-6 col-xl-4">
            <div className="card-beige border-0 mx-auto text-center p-0 bg-beige">
              <Calendar
                onChange={(d) => {
                  getBlocks(selectedArea, d);
                  setDate(d);
                }}
                className="react-calendar react-calendar__navigation react-calendar__tile"
                // tileClassName={({ date, view }) => {
                //   if (mark.find(x => x === moment(date).format("DD-MM-YYYY"))) {
                //     return 'highlight'
                //   }
                // }}
                value={date}
                locale="es-MX"
                minDate={new Date()}
                allowPartialRange={false}
              />
            </div>
          </li>
          <li className="col-12 col-sm-12 col-md-6 col-xl-4 my-1">
            <div className="d-flex align-items-center mb-3">
              <i className="circle bg-red" />
              <span className="ml-4 text-gray font-weight-bold">
                Fuera de servicio
              </span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <i className="circle bg-beige" />
              <span className="ml-4 text-gray font-weight-bold">
                Sin disponibilidad
              </span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <i className="circle bg-blue" />
              <span className="ml-4 text-gray font-weight-bold">
                Día Seleccionado
              </span>
            </div>
          </li>
          {blocksData.length && date ? (
            <div className="mx-auto my-4">
              <div className="col-12 my-4 text-center text-title">
                ¿Por cuánto tiempo quieres reservar?
              </div>
              <div className="d-flex flex-wrap justify-content-center">
                {blocksData.map((block) => {
                  return (
                    <li
                      className="col-6 col-sm-6 col-md-6 col-xl-4 text-center my-1"
                      key={block.id}
                    >
                      <button
                        onClick={() => {
                          handleSetSchedulesData(block.schedules);
                          setBlockArea(block);
                        }}
                        className={`${
                          blockArea.id === block.id ? "bg-green" : "bg-beige"
                        } card-beige p-4 border-0 btn-area`}
                      >
                        <div className="text-title text-center">
                          {block.name}
                        </div>
                        <div
                          className={`${
                            blockArea.id === block.id
                              ? "text-white"
                              : "text-gray"
                          } font-weight-bold`}
                        >
                          {block.availability}
                        </div>
                      </button>
                    </li>
                  );
                })}
              </div>
            </div>
          ) : (
            ""
          )}
          {schedulesData.length ? (
            <div className="mx-auto my-4">
              <div className="col-12 my-4 text-center text-title">
                Selecciona el horario de tu preferencia
              </div>
              <div className="d-flex flex-wrap justify-content-center">
                {schedulesData.map((item, i) => {
                  return (
                    <li
                      className="col-6 col-sm-6 col-md-6 col-xl-4 my-1 text-center"
                      key={i}
                    >
                      <button
                        onClick={() => setReservation(item)}
                        className={`${
                          reservation &&
                          reservation.start === item.start &&
                          reservation.end === item.end
                            ? "bg-green"
                            : "bg-beige"
                        } card-beige p-4 border-0 btn-area`}
                      >
                        <div className="text-title text-center">
                          {moment(item.start, "h").format("HH:mm")} -{" "}
                          {item.end >= 24
                            ? moment(item.end - 24, "h").format("HH:mm")
                            : moment(item.end, "h").format("HH:mm")}
                        </div>
                        <div
                          className={`${
                            reservation &&
                            reservation.start === item.start &&
                            reservation.end === item.end
                              ? "text-white"
                              : "text-gray"
                          }  font-weight-bold`}
                        >
                          {item.price ? "$".concat(item.price) : "Sin costo"}
                        </div>
                      </button>
                    </li>
                  );
                })}
              </div>
            </div>
          ) : (
            ""
          )}
          <li className="col-12 col-sm-12 col-md-6 col-xl-4 mt-5 pt-4 mx-auto">
            <div className="d-flex justify-content-center align-items-center">
              <Link
                to="/reservations"
                className="btn btn-new-incidence btn-muted mr-4 col-5 d-flex align-items-center justify-content-center text-center"
              >
                Cancelar
              </Link>
              <button
                type="button"
                disabled={
                  !reservation.start && !reservation.end && !reservation.price
                }
                onClick={onSubmit}
                className="btn btn-new-incidence col-5 d-flex align-items-center justify-content-center text-center"
              >
                Reservar
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

function Confirm({ selectedArea, date, reservation }) {
  return (
    <div className="container pt-4 text-center">
      <div className="text-center">
        <img src="assets/reservations/reserva-generada.svg" alt="" />
      </div>
      <div
        className="col-8 mx-auto mt-4 text-center text-blue font-weight-bold"
        style={{ fontSize: "45px" }}
      >
        ¡Reserva generada!
      </div>
      <p className="text-gray my-4">Resumen de tu reservación</p>
      <div className="card-beige mx-3 py-5 text-center bg-beige">
        <div className="text-center mb-3">
          <img
            className="w-100 font-weight-bold"
            width="70"
            height="70"
            src={`/assets/icons/${selectedArea.icon?.fileName}`}
            alt="img"
          />
        </div>
        <div className="text-title text-center">{selectedArea?.name}</div>
        <h5 className="text-gray my-3 font-weight-bold">
          {moment(date).format("DD-MM-YYYY")}
        </h5>
        <div className="text-title text-center">
          {reservation?.start}:00 - {reservation?.end}:00
        </div>
        <h5 className="text-gray mt-4 font-weight-bold">Cargo:</h5>
        <div className="text-title text-center">{reservation?.price}</div>
      </div>
      <p className="col-8 mx-auto mt-5 text-left">
        En breve recibirás un correo electrónico con la confirmación de tu
        reserva. El cargo de $200.00 pesos por esta reservación se verá
        reflejada en tu estado de cuenta de este mes.
      </p>
      <p className="col-8 mx-auto mt-5 font-weight-bold text-left">
        Es importante mencionar que una vez que se genera una reservación esta
        deberá ser respetada, si no se pudiera utilizar por cualquier motivo es
        importante que libere el horario reservado para que otros puedan hacer
        uso de las áreas, con un mínimo de 4 horas de anticipación, en caso de
        que el área tenga un costo, si no se cancela antes del tiempo indicado
        se generará un cargo descrito por la reserva.
      </p>
      <Link
        to="/reservations"
        className="btn mx-auto btn-new-incidence mt-5 col-8 d-flex align-items-center justify-content-center text-center"
      >
        Terminar
      </Link>
    </div>
  );
}

export default Create;
